import React, { useEffect, useState } from "react";
import Header from './../components/header';
import Footer from './../components/Footer';
import { PostDataAPI } from "./../components/services/ApiServices";
import { Link, useSearchParams } from "react-router-dom";
import { formatDate } from "../components/services/extension";

const TrackOrder = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Track order submitted");
    };
    const [searchParams] = useSearchParams();

    const track = searchParams.get("track");

    const [data, setData] = useState({ trackingNumber: track ? track : null })
    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const [errorMessages, setErrorMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [trackingData, setTrackingData] = useState([]);


    const validateTracking = (errorList) => {

        if (!data.trackingNumber || data.trackingNumber.trim() == '') {
            setErrorMessages(prevState => ({
                ...prevState,
                errorTrackingNumber: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorTrackingNumber: false
            }));
        }
    }

    const [activities, setActivities] = useState([]);

    const [errorMessage, setErrorMessage] = useState();

    const showDeliveryPhotoButton = activities?.some(
        item =>
            item?.status?.description?.toUpperCase() === "DELIVERED" ||
            item?.status?.type === "D"
    );

    const trackOrderSubmit = () => {
        let errorList = [];
        validateTracking(errorList);

        if (errorList.length < 1) {
            setIsLoading(true);

            PostDataAPI('figgorder/TrackShipment', data, true)
                .then((result) => {
                    console.log("Success Result:", result);

                    if (result.success === true) {
                        setActivities(
                            result.data.trackResponse.shipment[0].package[0].activity
                        );
                    } else {
                        setErrorMessage(result.message);
                    }

                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log("API Error:", error);

                    setErrorMessage(
                        error?.response?.data?.message ||
                        "Tracking number is invalid or not found. Please verify and try again."
                    );

                    setIsLoading(false);
                });
        }
    };

    useEffect(() => {
        trackOrderSubmit()
    }, [])


    return (
        <>
            <Header></Header>

            {activities.length > 0 ?
                <section className="track-section card">
                    <div className='shop_heading shop_container'>
                        <div className='text-center my-4'>
                            <h2>Track Your Order</h2>
                            <div className="divider m-1"></div>
                        </div>
                    </div>

                    <div className="shop_container">


                        <div className="track_wrapper" style={{ width: '100%' }}>
                            {showDeliveryPhotoButton && (
                                <div
                                    className="d-flex justify-content-end mb-3 pe-2"
                                    style={{ width: "100%" }}
                                >
                                    <Link
                                        className="nav-btn"
                                        to="#"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            window.open(
                                                `https://www.ups.com/track?track=yes&trackNums=${encodeURIComponent(
                                                    data.trackingNumber
                                                )}&loc=en_US&requester=ST/trackdetails`,
                                                "_blank"
                                            );
                                        }}
                                    >
                                        View Delivery Details
                                    </Link>
                                </div>
                            )}

                            <div className="table-responsive">
                                <table className="table tracking-table">
                                    <thead>
                                        <tr>
                                            <th>Status</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Location</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activities?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.status.description}</td>

                                                <td>{formatDate(item.date)}</td>

                                                <td>{item.time}</td>

                                                <td>
                                                    {item.location?.address?.city}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section> : <section className="track-section card">
                    <div className='shop_heading shop_container'>
                        <div className='text-center my-4'>
                            <h2>Track Your Order</h2>
                            <div className="divider" style={{ margin: '3 0' }}></div>
                        </div>
                    </div>

                    <div className="shop_container">

                        <div className="track-wrapper">

                            {/* Left Side */}
                            <div className="track-info">
                                <h2>Track Order</h2>
                                <p>
                                    Enter your order tracking number below to track your book order.
                                    You can find your order tracking number in your confirmation email.
                                </p>

                                <div className="info-box">
                                    <h4>Need Help?</h4>
                                    <a style={{ color: 'white' }} href='mailto:orders@desantis1776.com'>orders@desantis1776.com</a>
                                </div>
                            </div>

                            {/* Right Side Form */}
                            <div className="track-form-box">
                                <form onSubmit={handleSubmit}>

                                    <div className="form-group">
                                        <label>Order Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="trackingNumber"
                                            name="trackingNumber"
                                            value={data.trackingNumber}
                                            onChange={handleChange}
                                            placeholder="Enter your order tracking number"
                                            required
                                        />
                                    </div>



                                    <button type="submit" className="track-btn" onClick={trackOrderSubmit}>
                                        {isLoading ? <span className="button-spinner me-2"></span> : null} TRACK ORDER
                                    </button>

                                    <p className="field_errors m-2">{errorMessage}</p>

                                </form>
                            </div>

                        </div>



                    </div>
                </section>}

            <Footer />
        </>

    );
};

export default TrackOrder;
